export enum CheckinManagerHistoryMessages {
  ARCHIVE_LABEL = 'Archive',
  ARCHIVE_HEADING = 'Are you sure you want to archive these Check-In(s)',
}
